import { createElement } from "react";

export function anonymousSubid(cryptoObject = globalThis.crypto) {
  if (typeof cryptoObject?.randomUUID === "function") {
    return cryptoObject.randomUUID();
  }
  if (typeof cryptoObject?.getRandomValues === "function") {
    const values = cryptoObject.getRandomValues(new Uint32Array(4));
    return Array.from(values, (value) => value.toString(16).padStart(8, "0")).join("");
  }
  return `anon_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 14)}`;
}

export function partnerOutboundURL(partnerId, subid = anonymousSubid()) {
  return `/api/out/${encodeURIComponent(partnerId)}?s=${encodeURIComponent(subid)}`;
}

export function PartnerModule({ slots }) {
  if (!Array.isArray(slots) || slots.length === 0) return null;
  return createElement(
    "section",
    { className: "partner-module", "aria-label": "Sponsored links" },
    createElement("span", { className: "partner-module__label" }, "Sponsored"),
    createElement(
      "p",
      null,
      "Optional partner links. PricedPlay may receive compensation if you use one.",
    ),
    createElement(
      "div",
      { className: "partner-module__links" },
      ...slots.map((slot) => createElement(
        "a",
        {
          href: partnerOutboundURL(slot.id),
          key: slot.id,
          rel: "sponsored nofollow",
        },
        slot.label,
      )),
    ),
  );
}

export function AffiliateFooterLink({ enabled }) {
  return enabled
    ? createElement("a", { href: "/affiliate-disclosure" }, "Affiliate disclosure")
    : null;
}
